import { jsx as _jsx } from "react/jsx-runtime";
import { YoutubePlayer } from '~/components/YoutubePlayer/YoutubePlayer';
import { useStoreActions } from '~/contexts';
export function TutorialVideosPlayedVideo(param) {
    let { video, onWatch } = param;
    const { logBI } = useStoreActions();
    return /*#__PURE__*/ _jsx(YoutubePlayer, {
        width: "none",
        height: "none",
        controls: true,
        url: "https://youtu.be/".concat(video.id),
        testId: "tutorial-played-video",
        onStart: ()=>{
            if (!video.watched) {
                onWatch(video);
            }
            logBI(11215, {
                videoId: video.id,
                title: video.title
            });
        }
    });
}
